var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hash-list"},[_c('ul',{staticClass:"c-hash-list__items"},_vm._l((_vm.tags),function(tag,idx){return _c('li',{key:idx,staticClass:"c-hash-list__item"},[_c('router-link-ext',{attrs:{"to":{
          name: 'tagFeed',
          query: {
            title: ("#" + (tag.tag_nm)),
            tag_id: tag.tag_id,
          },
        }}},[_c('a',{staticClass:"c-hash-list__link"},[_vm._v("#"+_vm._s(tag.tag_nm))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }